export default __webpack_public_path__ + "static/media/Hekmalogo.cb052bb3.svg";